import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css'
import filter from '@/utils/filter.js'
import { Icon } from 'ant-design-vue'
import dayjs from 'dayjs'
import 'lib-flexible/flexible.js'
import { base_url } from '@/utils/request'

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2657748_x4scimbrvu9.js'
})
//挂载所有过滤器
for (const key in filter) {
  if (Object.prototype.hasOwnProperty.call(filter, key)) {
    const element = filter[key]
    Vue.filter(key, element)
  }
}

//去掉空格，判断是否为空
Vue.prototype.delSpace = function(str) {
  return str.replace(/\s+/g, '') == ''
}

Vue.component('IconFont', IconFont)
Vue.config.productionTip = false
Vue.prototype.base_url = base_url
Vue.prototype.dayjs = dayjs
Vue.prototype.getImportantName = (val) => {
  var lvs = [
      {
        text: '国家重点',
        value: 1
      },
      {
        text: '省重点',
        value: 2
      },
      {
        text: '市重点',
        value: 3
      },
      {
        text: '区重点',
        value: 4
      },
      {
        text: '普通科室',
        value: 5
      }
    ],
    txt
  lvs.forEach((item) => {
    if (item.value == val) {
      txt = item.text
    }
  })
  return txt
}
Vue.prototype.$toPage = (url) => {
  router.push(url)
}
Vue.use(Antd)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
